import http from "./http";

//加入购物车      /weChat/applet/shoppingCart/join/shoppingCart/{courseId}
function joinShoppingCart(courseId){
    let url = `/api/weChat/applet/shoppingCart/join/shoppingCart/${courseId}`;
    return  http.get(url)
}

// 查看我的购物车 /weChat/applet/shoppingCart/my/list
function listShoppingCart(status=""){
    let url = `/api/weChat/applet/shoppingCart/my/list?status=${status}`;
    return  http.get(url)
}

// 从购物车中删除   /weChat/applet/shoppingCart/remove/{shoppingCartId}
function removeShoppingCart(shoppingCartId){
    let url = `/api/weChat/applet/shoppingCart/remove/${shoppingCartId}`;
    return  http.get(url)
}
// 创建订单        /weChat/applet/order/batch/create/order
function  createOrder(courseIds) {
    let url =`/api/weChat/applet/order/batch/create/order`
    return http.post(url,{
            "courseIds":courseIds,
        })
}
// 调用支付模块  /course/order/payadd
function  payCourse(orderId,returnUrl) {
    let url =`/api/course/order/payadd`
    const formdata = new FormData();
    formdata.append("orderId",orderId);
    formdata.append("returnUrl",returnUrl);
    return  http.post(url,formdata)
}

// 小程序查看我的订单列表  /pc/order/my/list/{status}
function orderListPC(status, pageNumber, pageSize) {
    let url = `/api//pc/order/my/list/${status}?pageNum=${pageNumber}&pageSize=${pageSize}`;
    return  http.get(url)
}

// PC端查看我的订单列表  /weChat/applet/order/my/list/{status}
function orderList(status, pageNumber, pageSize) {
    let url = `/api/weChat/applet/order/my/list/${status}?pageNum=${pageNumber}&pageSize=${pageSize}`;
    return http.get(url)
}

// 订单删除     /weChat/applet/order/remove/{orderId}
function removeOrder(orderId){
    let url = `/api/weChat/applet/order/remove/${orderId}`;
    return  http.get(url)
}

// 小程序根据orderId端获取订单详情  /weChat/applet/order/detail/{orderId}
function orderDetail(orderId){
    let url = `/api/weChat/applet/order/detail/${orderId}`;
    return  http.get(url)
}

// PC端获取订单详情 /pc/order/detail/{orderId}
function orderDetailPC(orderId) {
    let url = `/api/pc/order/detail/${orderId}`;
    return http.get(url)
}

// 根据orderCode获取订单详情  /course/order/selectOrder
function  selectOrder(orderCode) {
    let url =`/api/course/order/selectOrder`
    const formdata = new FormData();
    formdata.append("orderCode",orderCode);

    return  http.post(url,formdata)
}


export {
    joinShoppingCart,
    listShoppingCart,
    removeShoppingCart,
    createOrder,
    payCourse,
    orderList,
    removeOrder,
    orderDetail,
    selectOrder,
    orderListPC,
    orderDetailPC
}
